// eslint-disable-next-line import/prefer-default-export
export const SECONDS = {
  DAY: 86400,
  HOUR: 3600,
  MINUTE: 60,
  MONTH: 2592000,
  WEEK: 604800,
  YEAR: 31536000,
};
